import { PackageSchedule } from './package-schedule';
import { BehaviorSubject, Subscriber, merge, Observable } from 'rxjs';
import { EventInput } from '@fullcalendar/core';
import { PackageScheduleService } from '../package-schedule.service';
import moment from 'moment';
import { Package } from 'src/app/shared/models/package.model';

export type DayStatus = 'BLOCKED' | 'OPEN' | 'PARTIALLY_BLOCKED';

export class PackageAggregator {

  private schedules = [] as PackageSchedule[];
  private changeDetector: Observable<any>;
  events = new BehaviorSubject<EventInput[]>([]);
  packagesFilter = new BehaviorSubject<number>(null);

  constructor(packages: Array<Package>, private service: PackageScheduleService) {
    this.init(packages);
  }

  init(packages: Array<Package>) {
    this.schedules = [];
    this.changeDetector = null;
    this.events.next([]);
    for (const travelPackage of packages) {
      const s = new PackageSchedule(travelPackage, this.service);
      this.schedules.push(s);
    }
    this.changeDetector = merge(
      ...this.schedules.map(sch => sch.formattedAvailability),
      this.packagesFilter
    );

    this.changeDetector.subscribe((v) => {
      this.collectEvents();
    });
  }

  collectEvents() {
    const events = [];
    let schedules = this.schedules;
    if (this.packagesFilter.value) {
      schedules = schedules.filter(sch => {
        return sch.travelPackage.id === this.packagesFilter.value;
      });
    }
    for (const sch of schedules) {
      events.push(...sch.formattedAvailability.value);
    }
    this.events.next(events);
  }

  getEventsAtDate(dateLike, withBlocked = false) {
    return this.events.value.filter(ev => {
      return (
        moment(dateLike).isSameOrAfter(ev.start, 'day') &&
        moment(dateLike).isSameOrBefore(ev.end, 'day')
      ) && (withBlocked ? true : ev.backgroundColor !== 'red');
    });
  }

  checkDayStatus(dateLike): DayStatus {
    const allDayEvents = this.getEventsAtDate(dateLike, true);
    const blockedEvents = allDayEvents.filter(e => e.backgroundColor === 'red');
    let status: DayStatus;
    if (blockedEvents.length === 0) {
      status =  'OPEN';
    } else if (allDayEvents.length === blockedEvents.length) {
      status =  'BLOCKED';
    } else {
      status =  'PARTIALLY_BLOCKED';
    }
    return status;
  }

  blockDay(dateLike, extras) {
    let schedules = this.schedules;
    if (this.packagesFilter.value) {
      schedules = this.schedules.filter(sch => {
        return sch.travelPackage.id === this.packagesFilter.value;
      });
    }

    for (const sch of schedules) {
      sch.blockDay(dateLike, extras);
    }
  }

  unblockDay(dateLike, extras?) {
    let schedules = this.schedules;
    if (this.packagesFilter.value) {
      schedules = this.schedules.filter(sch => {
        return sch.travelPackage.id === this.packagesFilter.value;
      });
    }

    for (const sch of schedules) {
      sch.unblockDay(dateLike);
    }
  }

}
